import React from "react";

/**
 * Reusable school letterhead.
 *
 * Renders a logo + school name + optional document subtitle. Pulls branding
 * from localStorage (set at login). Designed to sit at the top of any
 * printable document — invoices, receipts, fee structures, etc.
 *
 * Props:
 *   subtitle?  string  — small caption under the school name (e.g., "Fee Receipt").
 *   className? string  — extra wrapper class for layout tweaks per page.
 */
const Letterhead = ({ subtitle, className = "" }) => {
  const logo =
    localStorage.getItem("customer_logo") ||
    localStorage.getItem("customer_image") ||
    localStorage.getItem("school_logo") ||
    "";

  const schoolName =
    (localStorage.getItem("customer_name") || "").replace(/^"|"$/g, "") ||
    "School Name";

  const address = (localStorage.getItem("customer_address") || "").replace(
    /^"|"$/g,
    "",
  );
  const phone = (localStorage.getItem("customer_phone") || "").replace(
    /^"|"$/g,
    "",
  );
  const email = (localStorage.getItem("customer_email") || "").replace(
    /^"|"$/g,
    "",
  );

  return (
    <div className={`yc-letterhead ${className}`.trim()}>
      {logo ? (
        <img
          src={logo}
          alt="School Logo"
          className="yc-letterhead-logo"
          crossOrigin="anonymous"
          onError={(e) => {
            e.target.style.display = "none";
          }}
        />
      ) : null}
      <div className="yc-letterhead-text">
        <div className="yc-letterhead-school">{schoolName}</div>
        {(address || phone || email) && (
          <div className="yc-letterhead-meta">
            {[address, phone, email].filter(Boolean).join("  •  ")}
          </div>
        )}
        {subtitle ? (
          <div className="yc-letterhead-doc">{subtitle}</div>
        ) : null}
      </div>
    </div>
  );
};

export default Letterhead;
